<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M18 11.245a3.732 3.732 0 0 0-3.488-3.72A5.617 5.617 0 0 0 9 2.995c-.998 0-1.928.27-2.737.728L7.38 4.84A4.047 4.047 0 0 1 9 4.495a4.123 4.123 0 0 1 4.125 4.125v.375h1.125a2.247 2.247 0 0 1 1.342 4.05l1.058 1.057c.818-.69 1.35-1.702 1.35-2.857ZM3.308 2.89 2.25 3.948l2.077 2.077h-.314A4.496 4.496 0 0 0 0 10.495c0 2.482 2.018 4.5 4.5 4.5h8.797l1.5 1.5 1.058-1.058L3.308 2.89ZM4.5 13.495a3 3 0 1 1 0-6h1.298l6 6H4.5Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
